import { render } from "./HolyPlaces.vue?vue&type=template&id=30f2d566&scoped=true"
import script from "./HolyPlaces.vue?vue&type=script&lang=js"
export * from "./HolyPlaces.vue?vue&type=script&lang=js"

import "./HolyPlaces.vue?vue&type=style&index=0&id=30f2d566&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f2d566"]])

export default __exports__